
import data from './data'
import methods from './methods'
import mounted from './mounted'
import computed from './computed'
import components from './components'

export default {
  data,
  methods,
  mounted,
  computed,
  components,
  resourcePath: '/v1/dweller'
}



// WEBPACK FOOTER //
// ./src/app/dweller/profile/me/components/overview/resources/index.js